import React from "react";

export default class Paging extends React.Component {

    handleOnChangeSelectPageSize (event) {

        this.props.newPageSize(event.target.value);

    }

    render () {

        const pageSizeOptions = [];
        for (let i = 1; i <= 5; ++i) {

            pageSizeOptions.push(this.props.defaultPageSize * i);

        }

        return (
            <div className="paging">
                <div className="row">
                    <div className="col-sm-4 text-left">
                        <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => this.props.prevPage()}
                        >
                            <i className="material-icons">
                                navigate_before
                            </i>
                        </button>
                    </div>
                    <div className="col-sm-4 text-center">
                        {this.props.currPage}
                        {" "}
                        of
                        {" "}
                        {this.props.maxPage}
                        <select
                            className="form-control selectPageSize"
                            onChange={(e) => this.handleOnChangeSelectPageSize(e)}
                            value={this.props.pageSize}
                        >
                            {Object.keys(pageSizeOptions).map((i) => <option key={i}
value={pageSizeOptions[i]}>
{"Show " + pageSizeOptions[i]}
</option>)}
                        </select>
                    </div>
                    <div className="col-sm-4 text-right">
                        <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => this.props.nextPage()}
                        >
                            <i className="material-icons">
                                navigate_next
                            </i>
                        </button>
                    </div>
                </div>
            </div>
        );

    }

}
